import { SCREEN_TYPE, Screen } from '@/define/Adapter';

export const getIsMaxPage = (minWidth: number) => {
  const width = document.documentElement.clientWidth;
  return width >= minWidth;
};

export const getIsMinPage = (maxWidth: number) => {
  const width = document.documentElement.clientWidth;
  return width <= maxWidth;
};

const screenRules: Map<SCREEN_TYPE, (width: number) => boolean> = new Map();
screenRules.set(SCREEN_TYPE.MAX, getIsMaxPage);
screenRules.set(SCREEN_TYPE.MIN, getIsMinPage);

export const getMatchScreen = (screens: Screen[]) => {
  const matchScreen = screens.find((screen) => {
    const screenRule = screenRules.get(screen.type);
    if (screenRule) {
      return screenRule(screen.width);
    }
    return false;
  });
  return matchScreen;
};

export const heightToTop = (ele: HTMLElement | null) =>{
  if (!ele) return 0;
  //ele为指定跳转到该位置的DOM节点
  let root = document.body;
  let height = 0;
  do{
      height += ele.offsetTop;
      ele = ele.offsetParent as HTMLElement;
  } while ( ele !== root )
  return height;
}
